import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './api/axios'
import router from './router'   // 确保 router 是 Vue Router 3 实例
import './assets/css/style.css'

import { api } from '@/api/apis'

import * as routerHelper from '@/utils/router'

// 挂载到 Vue 原型，组件中可用 this.$goTo、this.$openExternal
Vue.prototype.$goTo = routerHelper.goTo
Vue.prototype.$goToReplace = routerHelper.goToReplace
Vue.prototype.$openExternal = routerHelper.openExternal


// 挂载到 Vue 原型，所有组件可通过 this.$api 访问
Vue.prototype.$api = api

Vue.use(ElementUI)
Vue.config.productionTip = false

// 挂载全局属性
Vue.prototype.$http = axios

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
console.log('初始化开始，当前host=', location.host)
new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    console.log('Vue beforeCreate 钩子触发')
  },
  created() {
    console.log('Vue created 钩子触发')
  },
  mounted() {
    console.log('Vue mounted完成，#app内部HTML：', document.getElementById('app').innerHTML)
  }
}).$mount('#app')